import cx from 'classnames'
import NextLegacyImage, { ImageProps } from 'next/legacy/image'
import { CSSProperties } from 'react'

import {
  getImageDimensions,
  getImageSource,
  getSanityImageLoader,
  ImageDimensions,
  PhotoImage,
} from '@lib/image'

interface PhotoProps {
  image: PhotoImage
  forceWidth?: number
  forceHeight?: number
  sizes?: string
  layout?: ImageProps['layout']
  objectFit?: ImageProps['objectFit']
  hasPlaceholder?: boolean
  priority?: boolean
  unoptimized?: boolean
  quality?: number
  className?: string
  style?: CSSProperties
}

const Photo = ({
  image,
  forceWidth,
  forceHeight,
  sizes,
  layout = 'intrinsic',
  objectFit,
  hasPlaceholder = true,
  priority = false,
  unoptimized,
  quality = 90,
  className,
  style,
}: PhotoProps) => {
  if (!image || !image.asset) {
    return null
  }

  const source = getImageSource(image)
  const blurDataUrl = (hasPlaceholder && 'lqip' in image ? image : {})?.lqip

  const dimensions: ImageDimensions =
    layout === 'fill' ? {} : getImageDimensions(image, forceWidth, forceHeight)
  const isFixedDimensions = (forceWidth && forceHeight) || image.fixedHeight

  return (
    <figure className={cx(className, 'photo-figure')} style={style}>
      <NextLegacyImage
        src={source}
        loader={getSanityImageLoader}
        width={dimensions?.width}
        height={dimensions?.height}
        sizes={sizes}
        quality={quality}
        priority={priority}
        unoptimized={unoptimized}
        layout={isFixedDimensions ? 'fixed' : layout}
        objectFit={objectFit}
        // TODO: Sometimes CSS blur filter does not go away when the image loads (not known what causes it).
        // blurDataURL={blurDataUrl}
        // placeholder={blurDataUrl ? 'blur' : 'empty'}
        alt={image.alt ?? ''}
        className={cx('block overflow-hidden')}
      />
    </figure>
  )
}

export default Photo
